"use client";

import { useEffect, useState } from "react";
import Link from "next/link";

export default function MobileMenu() {
  const [open, setOpen] = useState(false);
  const [links, setLinks] = useState<Array<{label:string; href:string}>>([])

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch('/api/header-links')
        const data = await res.json().catch(() => [])
        setLinks(Array.isArray(data) ? data : [])
      } catch {}
    })()
  }, [])

  const navLinks = links.filter(l => !!l.label && !!l.href);

  return (
    <>
      {/* Hamburger button */}
      <button
        aria-label="Abrir menú"
        aria-expanded={open}
        onClick={() => setOpen(true)}
        className="md:hidden w-9 h-9 flex flex-col items-center justify-center gap-1"
      >
        <span className="block w-6 h-[2px] bg-black" />
        <span className="block w-6 h-[2px] bg-black" />
        <span className="block w-6 h-[2px] bg-black" />
      </button>

      {/* Overlay */}
      <div
        className={`fixed inset-0 z-[60] bg-black/40 transition-opacity ${open ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}
        onClick={() => setOpen(false)}
      />

      {/* Slide-out panel */}
      <aside
        className={`fixed top-0 right-0 z-[70] h-full w-72 max-w-[85%] bg-white shadow-xl transition-transform duration-200 ${open ? 'translate-x-0' : 'translate-x-full'}`}
      >
        <div className="p-5 border-b border-[var(--muted)] flex items-center justify-between">
          <span className="font-mono text-sm">Menú</span>
          <button aria-label="Cerrar" onClick={() => setOpen(false)} className="w-8 h-8 flex items-center justify-center">✕</button>
        </div>
        <nav className="p-5 space-y-3 font-mono text-sm">
          {navLinks.map((l, i) => (
            <Link key={i} href={l.href} className="block py-2 border-b border-[var(--muted)]" onClick={() => setOpen(false)}>
              {l.label}
            </Link>
          ))}
          <Link href="/comprar" className="block py-2" onClick={() => setOpen(false)}>Compra ahora →</Link>
        </nav>
      </aside>
    </>
  );
}
